/** @format */

import { fromJS, List } from 'immutable';

const INITIAL_STATE = fromJS({
  list: [],
  sortedBy: 'createdAt',
  sortOrder: 'descending',
  loading: false,
  showDialog: false,
  isUploading: false,
  uploaded: false,
  uploadingProgress: 0,
  errors: {
    comment: [],
    binary: [],
    softwareVersion: [],
    circuit: []
  },
  uploadForm: {
    binary: null,
    comment: '',
    production: false,
    version: '',
    circuit: ''
  },
  circuits: []
});

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'GET_MOBILE_MODEM_FIRMWARES_START': {
      return state.set('loading', true);
    }
    case 'GET_MOBILE_MODEM_FIRMWARES_DONE': {
      const firmwares = action.payload.firmwares;
      return state.set('loading', true).set('list', fromJS(firmwares));
    }
    case 'GET_MOBILE_MODEM_FIRMWARES_FAILED': {
      return state.set('loading', false).set('list', List());
    }
    case 'OPEN_MOBILE_MODEM_FIRMWARE_DIALOG': {
      return state.set('showDialog', true).set('uploaded', false);
    }
    case 'CLOSE_MOBILE_MODEM_FIRMWARE_DIALOG': {
      return state.set('showDialog', false);
    }
    case 'MOBILE_MODEM_FIRMWARE_TABLE_ROW_EXPANDED': {
      let expandedRowId = action.payload.id;
      if (expandedRowId === state.get('expandedRow')) {
        expandedRowId = null;
      }
      return state.set('expandedRow', expandedRowId);
    }
    case 'MOBILE_MODEM_FIRMWARE_UPLOAD_FORM_CHANGE': {
      return state.setIn(
        ['uploadForm', action.payload.name],
        action.payload.value
      );
    }
    case 'MOBILE_MODEM_FIRMWARE_UPLOAD_START': {
      return state
        .set('isUploading', true)
        .set('uploaded', false)
        .set('uploadingProgress', 0);
    }
    case 'MOBILE_MODEM_FIRMWARE_UPLOAD_DONE': {
      return state
        .set('isUploading', false)
        .set('uploaded', true)
        .set(
          'uploadForm',
          INITIAL_STATE.get('uploadForm').set(
            'circuit',
            state.getIn(['uploadForm', 'circuit'])
          )
        );
    }
    case 'MOBILE_MODEM_FIRMWARE_UPLOAD_PROGRESS': {
      const progress =
        parseFloat(
          parseFloat(
            action.payload.progress.loaded / action.payload.progress.total
          ).toFixed(3)
        ) * 100;
      return state.set('uploadingProgress', progress);
    }
    case 'MOBILE_MODEM_FIRMWARE_UPLOAD_FORM_ERROR': {
      const errors = action.payload.errors;
      return state.set('errors', fromJS(errors)).set('isUploading', false);
    }
    case 'SESSION_LOGIN_DONE':
    case 'SESSION_CHECK_DONE': {
      const mobileModemCircuits = action.payload.mobileModemCircuits || [];
      return state
        .setIn(['uploadForm', 'circuit'], mobileModemCircuits[0])
        .set('circuits', fromJS(mobileModemCircuits));
    }
    case 'SESSION_LOGOUT_DONE': {
      return INITIAL_STATE;
    }
    default: {
      return state;
    }
  }
};
